/**
* @brandOverride URBNWeb
*/
import cartSagas from '../../../core/js/sagas/cartSagas';
import mislSagas from '../../../core/js/sagas/mislSagas';
import userSagas from '../../../core/js/sagas/userSagas';
import utagSagas from '../../../core/js/sagas/utagSagas';
import groundhogSagas from '../../../core/js/sagas/groundhogSagas';
import { getSaytSagas } from '../../../core/js/sagas/saytSagas';

import productAddToCartSagas from '../sagas/productAddToCartSagas';
import productBopisSagas from '../sagas/productBopisSagas';
import productCartSagas from '../sagas/productCartSagas';
import productInitialSagas from '../sagas/productInitialSagas';
import productReviewsSagas from '../sagas/productReviewsSagas';
import productSelectionSagas from '../sagas/productSelectionSagas';
import productWishListSagas from '../sagas/productWishListSagas';

import registrySagas from '../../../registry/js/sagas/registrySagas';

export const productStartingSagas = [
    ...cartSagas,
    ...mislSagas,
    ...getSaytSagas(),
    ...userSagas,
    ...utagSagas,
    ...productAddToCartSagas,
    ...productBopisSagas,
    ...productCartSagas,
    ...productInitialSagas,
    ...productReviewsSagas,
    ...productSelectionSagas,
    ...productWishListSagas,
    ...registrySagas,
    ...groundhogSagas
];

export default productStartingSagas;
